import React from 'react';
import moment from 'moment';
import { StyledModal, ModalContent, ModalField, ModalLabel, ModalValue, ModalLogValue, ModalActions, StyledButton } from './Styles';
import { LogDetailsModalProps } from './types';

const LogDetailsModal: React.FC<LogDetailsModalProps> = ({
  isOpen,
  selectedLog,
  isAdmin,
  onClose,
  theme,
}) => {
  return (
    <StyledModal
      title="Log Details"
      open={isOpen}
      onCancel={onClose}
      footer={null}
      theme={theme}
    >
      {selectedLog && ( 
        <ModalContent>
          <ModalField>
            <ModalLabel>Log ID</ModalLabel>
            <ModalValue>{selectedLog?.id}</ModalValue>
          </ModalField>

          <ModalField>
            <ModalLabel>Device Name</ModalLabel>
            <ModalValue>{selectedLog?.logDeviceName}</ModalValue>
          </ModalField>

          {isAdmin && (
            <ModalField>
              <ModalLabel>Merchant</ModalLabel>
              <ModalValue>{selectedLog?.merchant || 'N/A'}</ModalValue>
            </ModalField>
          )}

          <ModalField>
            <ModalLabel>Log</ModalLabel>
            <ModalLogValue theme={theme}>{selectedLog?.log}</ModalLogValue>
          </ModalField>

          <ModalField>
            <ModalLabel>Time</ModalLabel>
            <ModalValue>
              {moment(selectedLog?.timestamp).format('YYYY-MM-DD HH:mm:ss')}
            </ModalValue>
          </ModalField>

          <ModalActions>
            <StyledButton onClick={onClose}>Close</StyledButton>
          </ModalActions>
        </ModalContent>
      )}
    </StyledModal>
  );
};

export default LogDetailsModal;
